export const hotelIndex: any = {
  noCreditCard: "No Credit Card",
  refundable: "refundable",
  viewMap: "View Map",
  extraFeeNotice: "There is a tax or service charge to be paid at the hotel",
};
